// ERRORS
import { RavlError } from '../vendor/ravl/error';
import { isFalsy } from '../vendor/ravl//common';
import dict from '../vendor/ravl/schema';
import attachValidator from '../vendor/ravl/attachValidator';

// TODO: add errorResponse and successResponse in RestRequest

// ATTACHING BEHAVIORS
attachValidator(dict);

// Ticker Detail
{
    const name = 'tickerDetail';
    const schema = {
        doc: {
            name: 'Comparative Detail ',
            description: 'Ticker Detail',
        },
        fields: {
            ticker: { type: 'string', required: true },
            companyName: { type: 'string', required: false },
            sector: { type: 'string', required: false },
        },
    };
    dict.put(name, schema);
}

// Comparative Schema
{
    const name = 'comparativeDataPrice';
    const schema = {
        doc: {
            name: 'Comparative Data Price ',
            description: 'Comparative Data for Price',
        },
        fields: {
            latestClose: { type: 'number', required: false },
            OneEightyDayAverage: { type: 'number', required: false },
            todaysChange: { type: 'number', required: false },
            oneWeekPriceChange: { type: 'number', required: false },
            fourWeekPriceChange: { type: 'number', required: false },
            twelveWeekPriceChange: { type: 'number', required: false },
            oneYearPriceChange: { type: 'number', required: false },
            ytdChange: { type: 'number', required: false },

        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeDataMeasureOfSize';
    const schema = {
        doc: {
            name: 'Comparative Data Measure Of Size',
            description: 'Comparative Data for Measure Of Size',
        },
        fields: {
            MarketCap: { type: 'number', required: false },
            paidUpCapital: { type: 'number', required: false },
            reservesAndSurplus: { type: 'number', required: false },
            totalRevenue: { type: 'number', required: false },
            grossProfit: { type: 'number', required: false },
            netIncome: { type: 'number', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeDataMargins';
    const schema = {
        doc: {
            name: 'Comparative Data Margins',
            description: 'Comparative Data for Margins',
        },
        fields: {
            grossMarginMrq: { type: 'number', required: false },
            sgaMarginMrq: { type: 'number', required: false },
            ebitdaMarginMrq: { type: 'number', required: false },
            ebitdMarginMrq: { type: 'number', required: false },
            netProfitMarginMrq: { type: 'number', required: false },
            grossMarginTtm: { type: 'number', required: false },
            sgaMarginTtm: { type: 'number', required: false },
            ebitdaMarginTtm: { type: 'number', required: false },
            ebitMarginTtm: { type: 'number', required: false },
            netProfitMarginTtm: { type: 'number', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeDataManagementEffectiveness';
    const schema = {
        doc: {
            name: 'Comparative Data Management Effectiveness',
            description: 'Comparative Data for Management Effectiveness',
        },
        fields: {
            roeF: { type: 'number', required: false },
            roeMrq: { type: 'number', required: false },
            roeTtm: { type: 'number', required: false },
            roaF: { type: 'number', required: false },
            roaMrq: { type: 'number', required: false },
            roaTtm: { type: 'number', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeDataValuationMultiples';
    const schema = {
        doc: {
            name: 'Comparative Data ValuationMultiples',
            description: 'Comparative Data for Valuation Multiples',
        },
        fields: {
            epsF: { type: 'number', required: false },
            epsMrq: { type: 'number', required: false },
            epsTtm: { type: 'number', required: false },
            epsD: { type: 'number', required: false },
            bvp: { type: 'number', required: false },
            peD: { type: 'number', required: false },
            peF: { type: 'number', required: false },
            peMrq: { type: 'number', required: false },
            peTtm: { type: 'number', required: false },
            pbv: { type: 'number', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeDataLiquidityAndSolvency';
    const schema = {
        doc: {
            name: 'Comparative Data LiquidityAndSolvency',
            description: 'Comparative Data for LiquidityAndSolvency',
        },
        fields: {
            currentRatio: { type: 'number', required: false },
            quickRatio: { type: 'number', required: false },
            totalLiabilities: { type: 'number', required: false },
            quityMultiplier: { type: 'number', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeDataGrowthRate';
    const schema = {
        doc: {
            name: 'Comparative Data GrowthRate',
            description: 'Comparative Data for GrowthRate',
        },
        fields: {
            netIncomeOverPriorPeriod: { type: 'number', required: false },
            netIncomeYoy: { type: 'number', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeDataRisk';
    const schema = {
        doc: {
            name: 'Comparative Data Risk',
            description: 'Comparative Data for Risk',
        },
        fields: {
            betaWeekly: { type: 'number', required: false },
            betaMonthly: { type: 'number', required: false },
            var1WeekAt5: { type: 'number', required: false },
            var1WeekAt1: { type: 'number', required: false },
            var1MonthAt5: { type: 'number', required: false },
            var1MonthAt1: { type: 'number', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeDataTechnicalIndicators';
    const schema = {
        doc: {
            name: 'Comparative Data TechnicalIndicators',
            description: 'Comparative Data for TechnicalIndicators',
        },
        fields: {
            rsi: { type: 'number', required: false },
            macdCrossover: { type: 'number', required: false },
            relativeStrength: { type: 'number', required: false },
            FiftyDayMAVsTwoHundreadDayMA: { type: 'number', required: false },
            PriceVsFiftyTwoWeekHigh: { type: 'number', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeData';
    const schema = {
        doc: {
            name: 'Comparative Data',
            description: 'Comparative Data',
        },
        fields: {
            ticker: { type: 'string', required: true },
            price: { type: 'comparativeDataPrice', required: true },
            measureOfSize: { type: 'comparativeDataMeasureOfSize', required: true },
            margins: { type: 'comparativeDataMargins', required: true },
            managementEffectiveness: { type: 'comparativeDataManagementEffectiveness', required: true },
            valuationMultiples: { type: 'comparativeDataValuationMultiples', required: true },
            liquidityAndSolvency: { type: 'comparativeDataLiquidityAndSolvency', required: true },
            growthRate: { type: 'comparativeDataGrowthRate', required: true },
            risk: { type: 'comparativeDataRisk', required: true },
            technicalIndicators: { type: 'comparativeDataTechnicalIndicators', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeView';
    const schema = {
        doc: {
            name: 'Comparative View',
            description: 'Comparative View Schema',
        },
        fields: {
            criteria: { type: 'array.string', required: true },
            securities: { type: 'array.string', required: true },
        },
    };
    dict.put(name, schema);
}

// Overview Shemas
{
    const name = 'overviewIndicesData';
    const schema = {
        doc: {
            name: 'Overview Indices Data',
            description: 'Overview Indices Data',
        },
        fields: {
            nepse: { type: 'number' },
            sensitive: { type: 'number' },
            float: { type: 'number' },
            senFloat: { type: 'number' },
            banking: { type: 'number' },
            devBank: { type: 'number' },
            hydropower: { type: 'number' },
            finance: { type: 'number' },
            insurance: { type: 'number' },
            others: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewSectorData';
    const schema = {
        doc: {
            name: 'Overview Sector Data',
            description: 'Overview Sector Data',
        },
        fields: {
            currentValue: { type: 'number' },
            pc: { type: 'number' },
            pointChange: { type: 'number' },
            volume: { type: 'number' },
            advances: { type: 'number' },
            declines: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewTopBrokers';
    const schema = {
        doc: {
            name: 'Overview Top Borkers',
            description: 'Overview Top Borkers',
        },
        fields: {
            amount: { type: 'number' },
            brokerNumber: { type: 'number' },
            topBuy: { type: 'string' },
            topSell: { type: 'string' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewTopLosers';
    const schema = {
        doc: {
            name: 'Overview Top Losers',
            description: 'Overview Top Losers',
        },
        fields: {
            ticker: { type: 'string' },
            percentageChange: { type: 'number' },
            priceChange: { type: 'number' },
            price: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewTopGainers';
    const schema = {
        doc: {
            name: 'Overview Top Gainers',
            description: 'Overview Top Gainers',
        },
        extends: 'overviewTopLosers',
    };
    dict.put(name, schema);
}
{
    const name = 'overviewVolume';
    const schema = {
        doc: {
            name: 'Overview Top Volume',
            description: 'Overview Top Volume',
        },
        fields: {
            ticker: { type: 'string' },
            value: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewTransactions';
    const schema = {
        doc: {
            name: 'Overview Top Transaction',
            description: 'Overview Top Transaction',
        },
        extends: 'overviewVolume',
    };
    dict.put(name, schema);
}
{
    const name = 'overviewPriceAction';
    const schema = {
        doc: {
            name: 'Overview Price Action',
            description: 'Overview Price Action',
        },
        extends: 'equityPriceAction',
    };
    dict.put(name, schema);
}
{
    const name = 'overviewTimeSeries';
    const schema = {
        doc: {
            name: 'Overview Price Action',
            description: 'Overview Price Action',
        },
        extends: 'equityPriceAction',
        fields: {
            value: { type: 'number' },
            timeStamp: { type: 'number' },
        },
    };
    dict.put(name, schema);
}

// Equity Financials Schemas
{
    const name = 'equityFinancialsBaseFormat';
    const schema = {
        doc: {
            name: 'Equity Financial Base Format',
            description: 'Common Schema for equity Financial type\'s Format',
        },
        fields: {
            MySqlColumnName: { type: 'string', required: true },
            WorkSheetColumnName: { type: 'string' },
            HeadingStyle: { type: 'string', required: true },
            RowStyle: { type: 'string', required: true },
            Format: { type: 'string', required: true },
            Fchartdisplaystatus: { type: 'number' },
            Annualstatus: { type: 'number' },
            Quarterlystatus: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityFinancialsKeyStats';
    const schema = {
        doc: {
            name: 'Equity Financial for Key Stats',
            description: 'Schema for equity Financial Key Stats',
        },
        fields: {
            data: { type: 'array', required: true },
            format: { type: 'array.equityFinancialsBaseFormat', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityFinancialsBalanceSheet';
    const schema = {
        doc: {
            name: 'Equity Financial for Balance Sheet',
            description: 'Schema for equity Financial Balance Sheet',
        },
        fields: {
            data: { type: 'array', required: true },
            format: { type: 'array.equityFinancialsBaseFormat', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityFinancialsIncomeStatement';
    const schema = {
        doc: {
            name: 'Equity Financial for Income Statement',
            description: 'Schema for equity Financial Income Statement',
        },
        fields: {
            data: { type: 'array', required: true },
            format: { type: 'array.equityFinancialsBaseFormat', required: true },
        },
    };
    dict.put(name, schema);
}
// Equity Time Series Schemas
{
    const name = 'equityTimeSeries';
    const schema = {
        doc: {
            name: 'Equity Time Series',
            description: 'Equity Time Series',
        },
        fields: {
            value: { type: 'number' },
            timeStamp: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
// Equity Tearsheet Schemas
{
    const name = 'equityTearsheetPercentageChange';
    const schema = {
        doc: {
            name: 'Percentage Change',
            description: 'Percentage Change',
        },
        fields: {
            oneWeek: { type: 'number' },
            oneMonth: { type: 'number' },
            threeMonth: { type: 'number' },
            oneYear: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetStockInfo';
    const schema = {
        doc: {
            name: 'Stocke Info',
            description: 'Stocke Info',
        },
        fields: {
            reportedPaidup: { type: 'number' },
            listedShares: { type: 'number' },
            oneEightyAvg: { type: 'number' },
            betaMonthly: { type: 'number' },
            betaWeekly: { type: 'number' },
            varOneWeekFivePercent: { type: 'number' },
            varOneWeekOnePercent: { type: 'number' },
            varOneMonthFivePercent: { type: 'number' },
            varOneMonthOnePercent: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetKeyStatVsIndustryBasic';
    const schema = {
        doc: {
            name: 'Key Stat Vs Industry Basic Model',
            description: 'Key Stat Vs Industry Basic Model',
        },
        fields: {
            value: { type: 'number' },
            high: { type: 'number' },
            low: { type: 'number' },
            percentile: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetKeyStatVsIndustryBasicWithoutValue';
    const schema = {
        doc: {
            name: 'Key Stat Vs Industry Basic Model Without Value',
            description: 'Key Stat Vs Industry Basic Model Without Value',
        },
        fields: {
            high: { type: 'number' },
            low: { type: 'number' },
            percentile: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetKeyStatVsIndustry';
    const schema = {
        doc: {
            name: 'Key Stat Vs Industry',
            description: 'Key Stat Vs Industry',
        },
        fields: {
            eps: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            eps_d: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            eps_mrq: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            eps_ttm: { type: 'equityTearsheetKeyStatVsIndustryBasic' },

            pe: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            pe_d: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            pe_mrq: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            pe_ttm: { type: 'equityTearsheetKeyStatVsIndustryBasic' },

            pb: { type: 'equityTearsheetKeyStatVsIndustryBasic' },

            roe: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            roe_d: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            roe_mrq: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            roe_ttm: { type: 'equityTearsheetKeyStatVsIndustryBasic' },

            roa: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            roa_d: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            roa_mrq: { type: 'equityTearsheetKeyStatVsIndustryBasic' },
            roa_ttm: { type: 'equityTearsheetKeyStatVsIndustryBasic' },

            daysHighLow: { type: 'equityTearsheetKeyStatVsIndustryBasicWithoutValue' },
            fiftyTwoWeekHighLow: { type: 'equityTearsheetKeyStatVsIndustryBasicWithoutValue' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetLiquidityIndicator';
    const schema = {
        doc: {
            name: 'Liquidity Indicator',
            description: 'Liquidity Indicator',
        },
        fields: {
            daysTradedStockvsNepse: { type: 'number' },
            avgVol: { type: 'number' },
            daysTraded: { type: 'number' },
            avgVolume: { type: 'number' },
            avgNoOfTrades: { type: 'number' },
            avgSharesPerTrade: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetChangeSinceLastQuater';
    const schema = {
        doc: {
            name: 'Change Since Last Quater',
            description: 'Change Since Last Quater',
        },
        fields: {
            changeInProfitability: { type: 'number' },
            changeInSentiment: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetTechnicalIndicators';
    const schema = {
        doc: {
            name: 'Technical Indicators',
            description: 'Technical Indicators',
        },
        fields: {
            relativeStrength: { type: 'number' },
            fiftyDMaVs200d: { type: 'number' },
            priceVs52WkHigh: { type: 'number' },
            rsi: { type: 'number' },
            macd: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetMFundInfo';
    const schema = {
        doc: {
            name: 'Mutual Fund Info',
            description: 'Mutual Fund Info',
        },
        fields: {
            aum: { type: 'number' },
            cagr: { type: 'number' },
            discountToNav: { type: 'number' },
            fundBeta: { type: 'number' },
            monthVarAt1: { type: 'number' },
            monthlyNav: { type: 'number' },
            weeklyNav: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetMAssetAllocation';
    const schema = {
        doc: {
            name: 'Mutual Asset Allocation',
            description: 'Mutual Asset Allocation',
        },
        fields: {
            cash: { type: 'number' },
            equity: { type: 'number' },
            fixedIncome: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetMEquity';
    const schema = {
        doc: {
            name: 'Mutual Equity',
            description: 'Mutual Equity',
        },
        fields: {
            ticker: { type: 'string' },
            portWeight: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetMSector';
    const schema = {
        doc: {
            name: 'Mutual Sector',
            description: 'Mutual Sector',
        },
        fields: {
            label: { type: 'string' },
            value: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'MPercentageChange';
    const schema = {
        doc: {
            name: 'Mutual Percentage Change',
            description: 'Mutual Percentage Change',
        },
        fields: {
            bechmark: { type: 'number' },
            nav: { type: 'number' },
            price: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetMPercentageChangeChart';
    const schema = {
        doc: {
            name: 'Mutual Percentage Change Chart',
            description: 'Mutual Percentage Change Chart',
        },
        fields: {
            oneMonth: { type: 'MPercentageChange' },
            oneYear: { type: 'MPercentageChange' },
            threeMonth: { type: 'MPercentageChange' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetMSchemeInfo';
    const schema = {
        doc: {
            name: 'Mutual Scheme Info',
            description: 'Mutual Scheme Info',
        },
        fields: {
            baseSize: { type: 'string' },
            daysHighLow: { type: 'equityTearsheetKeyStatVsIndustryBasicWithoutValue' },
            fiftyTwoWeekHighLow: { type: 'equityTearsheetKeyStatVsIndustryBasicWithoutValue' },
            maturity: { type: 'string' },
            objective: { type: 'string' },
            scheme: { type: 'string' },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'equityTearsheet';
    const schema = {
        doc: {
            name: 'Equity Tearsheet Schema',
            description: 'Equity Tearsheet Schema',
        },
        fields: {
            timestamp: { type: 'number' },
            latestPrice: { type: 'number' },
            pointChange: { type: 'number' },
            percentChange: { type: 'number' },
            wtAvgPrice: { type: 'number' },
            sharesTraded: { type: 'number' },
            volume: { type: 'number' },
            mktCap: { type: 'number' },
            percentageChange: { type: 'equityTearsheetPercentageChange', required: true },
            stockInfo: { type: 'equityTearsheetStockInfo' },
            keyStatVsIndustry: { type: 'equityTearsheetKeyStatVsIndustry' },
            liquidityIndicator: { type: 'equityTearsheetLiquidityIndicator' },
            changeSinceLastQuater: { type: 'equityTearsheetChangeSinceLastQuater' },
            technicalIndicators: { type: 'equityTearsheetTechnicalIndicators' },

            // mutual extra fields
            fundInfo: { type: 'equityTearsheetMFundInfo' },
            assetAllocation: { type: 'equityTearsheetMAssetAllocation' },
            schemeInfo: { type: 'equityTearsheetMSchemeInfo' },
            equity: { type: 'array.equityTearsheetMEquity' },
            sector: { type: 'array.equityTearsheetMSector' },
            announcement: { type: 'array.equityAnnouncements' },
            percentageChangeChart: { type: 'equityTearsheetMPercentageChangeChart' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityDividendHistory';
    const schema = {
        doc: {
            name: 'Equity Dividend History Schema',
            description: 'Equity Dividend History Schema',
        },
        fields: {
            year: { type: 'string', required: true },
            cash: { type: 'number', required: true },
            bonus: { type: 'number', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityKeyFinancials';
    const schema = {
        doc: {
            name: 'Equity Key Financials Schema',
            description: 'Equity Key Financials Schema',
        },
        fields: {
            year: { type: 'string' },
            quarter: { type: 'uint' },
            totalRevenue: { type: 'number' },
            growthOverPriorPeriod: { type: 'number' },
            grossProfit: { type: 'number' },
            grossProfitMargin: { type: 'number' },
            netIncome: { type: 'number' },
            netIncomeMargin: { type: 'number' },
            epsAnnualized: { type: 'number' },
            bookValuePerShare: { type: 'number' },
            returnOnAsset: { type: 'number' },
            returnOnEquity: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityAnnouncements';
    const schema = {
        doc: {
            name: 'Equity Announcement Schema',
            description: 'Equity Announcement Schema',
        },
        fields: {
            id: { type: 'uint' },
            ticker: { type: 'string' },
            companyName: { type: 'string' },
            inputDate: { type: 'uint' },
            type: { type: 'string' },
            fiscalYear: { type: 'string' },
            detail: { type: 'string' },
            announcementType: { type: 'string' },
            shareRegistrar: { type: 'string' },
            eventDate: { type: 'uint' },

            openDate: { type: 'uint' },
            closeDate: { type: 'uint' },
            bookCloseDate: { type: 'uint' },
            allotmentDate: { type: 'uint' },

            time: { type: 'string' },
            venue: { type: 'string' },
            agenda: { type: 'string' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityPriceAction';
    const schema = {
        doc: {
            name: 'Equity Price Action',
            description: 'Equity Price Action',
        },
        fields: {
            priceAction: { type: 'string' },
            header: { type: 'string' },
            actionType: { type: 'string' },
            timestamp: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
// Base Schemas
{
    const name = 'getResponseBase';
    const schema = {
        doc: {
            name: 'GET Response Base',
            description: 'Common response for GET',
        },
        fields: {
            responseCode: { type: 'uint', required: true },
        },
    };
    dict.put(name, schema);
}

//  Announcement Schemas
{
    const name = 'announcementBase';
    const schema = {
        doc: {
            name: 'Announcement Base',
            description: 'Announcement Model with common field',
        },
        fields: {
            id: { type: 'uint', required: true },
            ticker: { type: 'string', required: false },
            inputDate: { type: 'uint', required: true },
            announcementType: { type: 'string', required: false },
            fiscalYear: { type: 'string', required: false },
            detail: { type: 'string', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'announcementNepseCircular';
    const schema = {
        doc: {
            name: 'Announcement: NEPSE Circular',
            description: 'One of the announcement entities',
        },
        extends: 'announcementBase',
        fields: {
            details: { type: 'string', required: false },
            eventDate: { type: 'uint', required: false },
            agenda: { type: 'string', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'announcementFinancials';
    const schema = {
        doc: {
            name: 'Announcement: Financials',
            description: 'One of the announcement entities',
        },
        extends: 'announcementBase',
    };
    dict.put(name, schema);
}
{
    const name = 'announcementIpoFpo';
    const schema = {
        doc: {
            name: 'Announcement: IPO/FPO',
            description: 'One of the announcement entities',
        },
        extends: 'announcementBase',
        fields: {
            ticker: { type: 'string', required: false },
            companyName: { type: 'string', required: false },
            openDate: { type: 'uint', required: false },
            closeDate: { type: 'uint', required: false },
            agenda: { type: 'string', required: true },
            shareRegistrar: { type: 'string', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'announcementRightShares';
    const schema = {
        doc: {
            name: 'Announcement: Right Shares',
            description: 'One of the announcement entities',
        },
        extends: 'announcementBase',
        fields: {
            agenda: { type: 'string', required: false },
            eventDate: { type: 'uint', required: false },
            openDate: { type: 'uint', required: false },
            closeDate: { type: 'uint', required: false },
            bookCloseDate: { type: 'uint', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'announcementAuction';
    const schema = {
        doc: {
            name: 'Announcement: Auction',
            description: 'One of the announcement entities',
        },
        extends: 'announcementBase',
        fields: {
            openDate: { type: 'uint', required: false },
            closeDate: { type: 'uint', required: false },
            allotmentDate: { type: 'uint', required: false },
            shareRegistrar: { type: 'string', required: false },
            agenda: { type: 'string', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'announcementBondDebenture';
    const schema = {
        doc: {
            name: 'Announcement: Bond Debenture',
            description: 'One of the announcement entities',
        },
        extends: 'announcementBase',
        fields: {
            ticker: { type: 'string', required: false },
            companyName: { type: 'string', required: false },
            agenda: { type: 'string', required: false },
            eventDate: { type: 'uint', required: false },
            openDate: { type: 'uint', required: false },
            closeDate: { type: 'uint', required: false },
            shareRegistrar: { type: 'string', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'announcementAgmSgm';
    const schema = {
        doc: {
            name: 'Announcement: AgmSgm',
            description: 'One of the announcement entities',
        },
        extends: 'announcementBase',
        fields: {
            ticker: { type: 'string', required: false },
            eventDate: { type: 'uint', required: false },
            bookCloseDate: { type: 'uint', required: false },
            agenda: { type: 'string', required: false },
            venue: { type: 'string', required: false },
            time: { type: 'string', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'announcementDividend';
    const schema = {
        doc: {
            name: 'Announcement: Dividend',
            description: 'One of the announcement entities',
        },
        extends: 'announcementBase',
        fields: {
            eventDate: { type: 'uint', required: false },
            bookCloseDate: { type: 'uint', required: false },
            agenda: { type: 'string', required: true },
        },
    };
    dict.put(name, schema);
}


// ATTACHING USER DEFINED SCHEMAS
{
    const name = 'userInfoResponse';
    const schema = {
        doc: {
            name: 'User Info',
            description: 'Response for /systemxlt/userInfo',
        },
        fields: {
            username: { type: 'string', required: true },
            phone: { type: 'string', required: false },
            expiryDate: { type: 'number', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'userResponseSchema';
    const schema = {
        doc: {
            name: 'User Response',
            description: 'Response for /user/:id',
            note: 'The identifier id is not used right now.',
        },
        fields: {
            username: { type: 'uint', required: true },
            address: { type: 'string', required: false },
            token: { type: 'string', required: true },
        },
        validator: (self, context) => {
            if (isFalsy(self.token)) {
                return;
            }
            if (self.token.length <= 5) {
                throw new RavlError('Length must be greater than 5', context);
            }
        },
    };
    dict.put(name, schema);
}
{
    const name = 'registerResponse';
    const schema = {
        doc: {
            name: 'User Register Response',
            description: 'Response for /systemxLt/register',
        },
        fields: {
            action: { type: 'string' },
            responseCode: { type: 'number', required: true },
            userId: { type: 'number', required: true },
            message: { type: 'string', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'npstocksRegisterResponse';
    const schema = {
        doc: {
            name: 'User Register Response',
            description: 'Response for /npstocks/v2/register',
        },
        fields: {
            response: { type: 'string' },
            error: { type: 'string' },
            status: { type: 'string', required: true },
            statusCode: { type: 'number', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'loginResponse';
    const schema = {
        doc: {
            name: 'User Login Response',
            description: 'Response for /systemxLt/login',
        },
        fields: {
            action: { type: 'string' },
            responseCode: { type: 'number', required: true },
            userId: { type: 'number', required: true },
            message: { type: 'string', required: true },
            firstLogIn: { type: 'boolean', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'NpstocksLoginResponse';
    const schema = {
        doc: {
            name: 'User Npstocks Login Response',
            description: 'Response for /npstocks/v2/login',
        },
        fields: {
            error: { type: 'string' },
            firstLogin: { type: 'boolean', required: true },
            userId: { type: 'number', required: true },
            token: { type: 'string', required: true },
            username: { type: 'string', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'tokenSyncResponse';
    const schema = {
        doc: {
            name: 'Token Sync Response',
            description: 'Response for /systemxLt/tokenSync',
        },
        fields: {
            action: { type: 'string' },
            responseCode: { type: 'number', required: true },
            userId: { type: 'number', required: true },
            message: { type: 'string', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'changePasswordResponse';
    const schema = {
        doc: {
            name: 'Change Password Response',
            description: 'Response for /systemxLt/changePassword',
        },
        fields: {
            action: { type: 'string' },
            responseCode: { type: 'number', required: true },
            userId: { type: 'number', required: true },
            message: { type: 'string', required: true },
            firstLogIn: { type: 'boolean', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'logoutResponse';
    const schema = {
        doc: {
            name: 'Logout Response',
            description: 'Response for /systemxLt/logout',
        },
        fields: {
            action: { type: 'string' },
            responseCode: { type: 'number', required: true },
            userId: { type: 'number', required: true },
            message: { type: 'string', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'paymentScheme';
    const schema = {
        doc: {
            name: 'Payment Scheme ',
            description: 'Payment Scheme',
        },
        fields: {
            id: { type: 'number', isRequired: true },
            description: { type: 'string', isRequired: true },
            discountDescription: { type: 'string', isRequired: true },
            price: { type: 'number', isRequired: true },
            discount: { type: 'number', isRequired: true },
            isEnabled: { type: 'boolean', isRequired: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'paymentSchemeResponse';
    const schema = {
        doc: {
            name: 'Payment Scheme Get Response',
            description: 'GET for Payment Scheme',
        },
        fields: {
            action: { type: 'string' },
            responseCode: { type: 'number', required: true },
            userId: { type: 'number', required: true },
            message: { type: 'array.paymentScheme', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'errorResponse';
    const schema = {
        doc: {
            name: 'Error Response',
            description: 'Response for any error message',
        },
        fields: {
            message: { type: 'string', required: true },
            responseCode: { type: 'uint', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'successResponse';
    const schema = {
        doc: {
            name: 'Success Response',
            description: 'Response for success message',
        },
        fields: {
            message: { type: 'object', required: true },
            responseCode: { type: 'uint', required: true },
        },
    };
    dict.put(name, schema);
}

// Ticker Detail
{
    const name = 'tickerDetailResponse';
    const schema = {
        doc: {
            name: 'Comparative Detail List Response',
            description: 'Ticker Detail List Response',
        },
        fields: {
            responseCode: { type: 'uint', required: true },
            dataType: { type: 'string', required: true },
            data: { type: 'array.tickerDetail', required: true },
        },
    };
    dict.put(name, schema);
}

// Comparative request related
{
    const name = 'comparativeDataResponse';
    const schema = {
        doc: {
            name: 'Comparative Data Response',
            description: 'Response for comparative data request',
        },
        fields: {
            data: { type: 'array.comparativeData', required: true },
            section: { type: 'string', required: false },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeViewResponse';
    const schema = {
        doc: {
            name: 'Comparative View Response',
            description: 'Comparative View Schema Response',
        },
        extends: 'comparativeView',
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeViewSaveResponse';
    const schema = {
        doc: {
            name: 'Comparative View Save Response',
            description: 'Comparative View Schema POST Response',
        },
        fields: {
            data: { type: 'array.comparativeData', required: true },
            schema: { type: 'comparativeView', required: true },

        },
    };
    dict.put(name, schema);
}
{
    const name = 'comparativeViewDataResponse';
    const schema = {
        doc: {
            name: 'Comparative View Data Response',
            description: 'Comparative View Data Response',
        },
        fields: {
            data: { type: 'array.comparativeData', required: true },
            dataType: { type: 'string', required: true },
            responseCode: { type: 'uint', required: true },
        },
    };
    dict.put(name, schema);
}

// HomeScreen
{
    const name = 'homeScreenUpcomingEvents';
    const schema = {
        doc: {
            name: 'Home Screen Upcoming Events Response',
            description: 'Home Screen Upcoming Events Response',
        },
        fields: {
            id: { type: 'uint' },
            daysToGo: { type: 'number' },
            ticker: { type: 'string' },
            company: { type: 'string' },
            details: { type: 'string' },
            eventType: { type: 'string' },
            inputDate: { type: 'number' },
            eventDate: { type: 'number' },
            openDate: { type: 'number' },
            closeDate: { type: 'number' },
            allotmentDate: { type: 'number' },
            bookCloseDate: { type: 'number' },
            time: { type: 'string' },
            venue: { type: 'string' },
            agenda: { type: 'string' },
            fiscalYear: { type: 'string' },
            shareRegistrar: { type: 'string' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'homeScreenTodaysAnnouncements';
    const schema = {
        doc: {
            name: 'Home Screen Upcoming Events Response',
            description: 'Home Screen Upcoming Events Response',
        },
        fields: {
            id: { type: 'uint' },
            ticker: { type: 'string' },
            companyName: { type: 'string' },
            detail: { type: 'string' },
            announcementType: { type: 'string' },
            inputDate: { type: 'number' },
            eventDate: { type: 'number' },
            openDate: { type: 'number' },
            closeDate: { type: 'number' },
            allotmentDate: { type: 'number' },
            bookCloseDate: { type: 'number' },
            time: { type: 'string' },
            venue: { type: 'string' },
            agenda: { type: 'string' },
            fiscalYear: { type: 'string' },
            shareRegistrar: { type: 'string' },

        },
    };
    dict.put(name, schema);
}
{
    const name = 'homeScreenTodaysEvent';
    const schema = {
        doc: {
            name: 'Home Screen Upcoming Events Response',
            description: 'Home Screen Upcoming Events Response',
        },
        fields: {
            id: { type: 'uint' },
            ticker: { type: 'string' },
            company: { type: 'string' },
            details: { type: 'string' },
            eventType: { type: 'string' },
            inputDate: { type: 'number' },
            eventDate: { type: 'number' },
            openDate: { type: 'number' },
            closeDate: { type: 'number' },
            allotmentDate: { type: 'number' },
            bookClose: { type: 'number' },
            time: { type: 'string' },
            venue: { type: 'string' },
            agenda: { type: 'string' },
            fiscalYear: { type: 'string' },
            shareRegistrar: { type: 'string' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'homeMovers';
    const schema = {
        doc: {
            name: 'Home Screen Movers Response',
            description: 'Home Screen Movers Response',
        },
        fields: {
            ticker: { type: 'string' },
            pointChange: { type: 'number' },
            percentageChange: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'homePortfolico';
    const schema = {
        doc: {
            name: 'Home Screen Portfolio Response',
            description: 'Home Screen Portfolio Response',
        },
        fields: {
            portfolio: { type: 'number' },
            todayGain: { type: 'number' },
            todayGainPercentage: { type: 'number' },
            overallGain: { type: 'number' },
            overallGainPercentage: { type: 'number' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'watchListTickers';
    const schema = {
        doc: {
            name: 'Home Screen Portfolio Response',
            description: 'Home Screen Portfolio Response',
        },
        fields: {
            ticker: { type: 'array.string', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'watchList';
    const schema = {
        doc: {
            name: 'Home Screen Portfolio Response',
            description: 'Home Screen Portfolio Response',
        },
        fields: {
            ticker: { type: 'string', required: true },
            lastTradedPrice: { type: 'number' },
            vol: { type: 'number' },
            pointChange: { type: 'number' },
            percentageChange: { type: 'number' },
            priceActions: { type: 'equityPriceAction' },
        },
    };
    dict.put(name, schema);
}

// Announcment request related
{
    const name = 'AnnouncementNepseCircularGetResponse';
    const schema = {
        doc: {
            name: 'NEPSE Circular Announcements Get Response',
            description: 'Response for GET urlForAnnouncementNepseCircular',
        },
        extends: 'getResponseBase',
        fields: {
            message: { type: 'array.announcementNepseCircular', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'AnnouncementFinancialsGetResponse';
    const schema = {
        doc: {
            name: 'Financial Announcements Get Response',
            description: 'Response for GET /announcement/financials',
        },
        extends: 'getResponseBase',
        fields: {
            message: { type: 'array.announcementFinancials', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'AnnouncementIpoFpoGetResponse';
    const schema = {
        doc: {
            name: 'IPO/FPO Announcements Get Response',
            description: 'Response for GET /announcement/ipo-fpo',
        },
        extends: 'getResponseBase',
        fields: {
            message: { type: 'array.announcementIpoFpo', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'AnnouncementRightSharesGetResponse';
    const schema = {
        doc: {
            name: 'RightShares Announcements Get Response',
            description: 'Response for GET /announcement/right-shares',
        },
        extends: 'getResponseBase',
        fields: {
            message: { type: 'array.announcementRightShares', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'AnnouncementAuctionGetResponse';
    const schema = {
        doc: {
            name: 'AuctionAnnouncements Get Response',
            description: 'Response for GET /announcement/auction',
        },
        extends: 'getResponseBase',
        fields: {
            message: { type: 'array.announcementAuction', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'AnnouncementBondDebentureGetResponse';
    const schema = {
        doc: {
            name: 'BondDebenture Announcements Get Response',
            description: 'Response for GET /announcement/',
        },
        extends: 'getResponseBase',
        fields: {
            message: { type: 'array.announcementBondDebenture', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'AnnouncementAgmSgmGetResponse';
    const schema = {
        doc: {
            name: 'AgmSgm Announcements Get Response',
            description: 'Response for GET /announcement/',
        },
        extends: 'getResponseBase',
        fields: {
            message: { type: 'array.announcementAgmSgm', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'AnnouncementDividendGetResponse';
    const schema = {
        doc: {
            name: 'Dividend Announcements Get Response',
            description: 'Response for GET /announcement/',
        },
        extends: 'getResponseBase',
        fields: {
            message: { type: 'array.announcementDividend', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'equityFinancialsKeyStatsResponse';
    const schema = {
        doc: {
            name: 'Equity Financial Key Stats Response',
            description: 'GET Response for Equity Financial Key Stats',
        },
        extends: 'equityFinancialsKeyStats',
        fields: {
            responseCode: { type: 'uint', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityFinancialsBalanceSheetResponse';
    const schema = {
        doc: {
            name: 'Equity Financial Balance Sheet Response',
            description: 'GET Response for Equity Financial Balance Sheet',
        },
        extends: 'equityFinancialsBalanceSheet',
        fields: {
            responseCode: { type: 'uint', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityFinancialsIncomeStatementResponse';
    const schema = {
        doc: {
            name: 'Equity Financial Income Statement Response',
            description: 'GET Response for Equity Financial Income Statement',
        },
        extends: 'equityFinancialsIncomeStatement',
        fields: {
            responseCode: { type: 'uint', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTearsheetResponse';
    const schema = {
        doc: {
            name: 'Equity Tearsheet Response',
            description: 'GET Response Equity Tearsheet',
        },
        fields: {
            responseCode: { type: 'uint' },
            dataType: { type: 'string' },
            message: { type: 'equityTearsheet', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityKeyFinancialsAndAnnouncementResponse';
    const schema = {
        doc: {
            name: 'Equity Tearsheet Response',
            description: 'GET Response Equity Tearsheet',
        },
        fields: {
            responseCode: { type: 'uint' },
            keyFinancial: { type: 'array.equityKeyFinancials', required: true },
            announcement: { type: 'array.equityAnnouncements', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityDividendHistoryResponse';
    const schema = {
        doc: {
            name: 'Equity Mutual Fund Dividend History Response',
            description: 'GET Response Equity Mutual Fund Dividend History',
        },
        fields: {
            responseCode: { type: 'uint' },
            message: { type: 'array.equityDividendHistory', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityTimeSeriesResponse';
    const schema = {
        doc: {
            name: 'Equity Mutual Fund Dividend History Response',
            description: 'GET Response Equity Mutual Fund Dividend History',
        },
        fields: {
            responseCode: { type: 'uint' },
            data: { type: 'array.equityTimeSeries', required: true },
        },
    };
    dict.put(name, schema);
}
// Overview Response Schemas
{
    const name = 'overviewSectorDataResponse';
    const schema = {
        doc: {
            name: 'Overview Sector Data Response',
            description: 'GET Overview Sector Data',
        },
        fields: {
            responseCode: { type: 'uint' },
            data: { type: 'overviewSectorData', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityPriceActionResponse';
    const schema = {
        doc: {
            name: 'Equity Price Actions Response',
            description: 'GET Equity Price Actions',
        },
        fields: {
            responseCode: { type: 'uint' },
            data: { type: 'array.equityPriceAction', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewIndicesDataResponse';
    const schema = {
        doc: {
            name: 'Overview Indices Data Response',
            description: 'GET Overview Indices Data',
        },
        fields: {
            responseCode: { type: 'uint' },
            data: { type: 'overviewIndicesData', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewTopBrokersResponse';
    const schema = {
        doc: {
            name: 'Overview Top Borkers Response',
            description: 'GET Overview Top Borkers',
        },
        fields: {
            responseCode: { type: 'uint' },
            data: { type: 'array.overviewTopBrokers', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewTopLosersGainersResponse';
    const schema = {
        doc: {
            name: 'Overview Top Losers and Gainers Response',
            description: 'GET Overview Top Losers and Gainers',
        },
        fields: {
            responseCode: { type: 'uint' },
            gainers: { type: 'array.overviewTopGainers', required: true },
            losers: { type: 'array.overviewTopLosers', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewActiveTurnoverResponse';
    const schema = {
        doc: {
            name: 'Overview Top Volume Transaction Response',
            description: 'GET Overview Top Volume Transaction',
        },
        fields: {
            responseCode: { type: 'uint' },
            volume: { type: 'array.overviewVolume', required: true },
            transactions: { type: 'array.overviewTransactions', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewPriceActionResponse';
    const schema = {
        doc: {
            name: 'Overview Price Actions Response',
            description: 'GET Overview Price Actions Response',
        },
        fields: {
            responseCode: { type: 'uint' },
            data: { type: 'array.overviewPriceAction', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'overviewTimeSeriesResponse';
    const schema = {
        doc: {
            name: 'Overview Price Actions Response',
            description: 'GET Overview Price Actions Response',
        },
        fields: {
            responseCode: { type: 'uint' },
            lineChart: { type: 'array.overviewTimeSeries', required: true },
            barChart: { type: 'array.overviewTimeSeries', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'equityFinancialsResponse';
    const schema = {
        doc: {
            name: 'Equity Financial Response',
            description: 'GET Equity Financial',
        },
        fields: {
            responseCode: { type: 'uint' },
            data: { type: 'array', required: true },
            format: { type: 'array', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'homeScreenUpcomingEventsResponse';
    const schema = {
        doc: {
            name: 'Home Screen Upcoming Events Response',
            description: 'GET Home Screen Upcoming Events',
        },
        fields: {
            responseCode: { type: 'uint' },
            dataType: { type: 'string' },
            message: { type: 'array.homeScreenUpcomingEvents', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'homeScreenTodaysAnnouncementsResponse';
    const schema = {
        doc: {
            name: 'Home Screen Upcoming Events Response',
            description: 'GET Home Screen Upcoming Events',
        },
        fields: {
            responseCode: { type: 'uint' },
            dataType: { type: 'string' },
            message: { type: 'array.homeScreenTodaysAnnouncements', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'homeScreenTodaysEventReponse';
    const schema = {
        doc: {
            name: 'Home Screen Upcoming Events Response',
            description: 'GET Home Screen Upcoming Events',
        },
        fields: {
            responseCode: { type: 'uint' },
            dataType: { type: 'string' },
            message: { type: 'array.homeScreenTodaysEvent', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'homeMoversResponse';
    const schema = {
        doc: {
            name: 'Home Screen Movers Response',
            description: 'GET Home Screen Movers',
        },
        fields: {
            responseCode: { type: 'uint' },
            dataType: { type: 'string' },
            gainers: { type: 'array.homeMovers', required: true },
            losers: { type: 'array.homeMovers', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'homePortfolioResponse';
    const schema = {
        doc: {
            name: 'Home Screen Portfolio Response',
            description: 'GET Home Screen Portfolio',
        },
        fields: {
            responseCode: { type: 'uint' },
            dataType: { type: 'string', required: true },
            message: { type: 'homePortfolico', required: true },
        },
    };
    dict.put(name, schema);
}

{
    const name = 'watchListResponse';
    const schema = {
        doc: {
            name: 'Watch List Response',
            description: 'GET Watch List',
        },
        fields: {
            responseCode: { type: 'uint' },
            dataType: { type: 'string' },
            message: { type: 'array.watchList', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'watchListTickersResponse';
    const schema = {
        doc: {
            name: 'Watch List Tickers Response',
            description: 'GET Watch List Tickers',
        },
        fields: {
            responseCode: { type: 'uint' },
            dataType: { type: 'string' },
            message: { type: 'watchListTickers', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'homeScreenWatchListSaveResponse';
    const schema = {
        doc: {
            name: 'Watch List Tickers Response',
            description: 'POST Watch List Tickers',
        },
        fields: {
            responseCode: { type: 'uint' },
            dataType: { type: 'string' },
            watchlist: { type: 'array.watchList', required: true },
            tickers: { type: 'watchListTickers', required: true },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'passwordResetResponse';
    const schema = {
        doc: {
            name: 'Password Reset Response',
            description: 'Password Reset Response',
        },
        fields: {
            responseCode: { type: 'uint', required: true },
            action: { type: 'string' },
            message: { type: 'string' },
            userId: { type: 'uint' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'npstocksPasswordResetResponse';
    const schema = {
        doc: {
            name: 'Password Reset Response',
            description: 'Password Reset Response',
        },
        fields: {
            statusCode: { type: 'uint', required: true },
            response: { type: 'string' },
            status: { type: 'string', required: true },
            error: { type: 'string' },
        },
    };
    dict.put(name, schema);
}
{
    const name = 'npstocksPasswordResetResponsePin';
    const schema = {
        doc: {
            name: 'Password Reset Response Pin',
            description: 'Password Reset Response Pin',
        },
        fields: {
            statusCode: { type: 'uint', required: true },
            response: { type: 'string' },
            status: { type: 'string', required: true },
            error: { type: 'string' },
        },
    };
    dict.put(name, schema);
}

export default dict;
export { RavlError } from '../vendor/ravl/error';



// WEBPACK FOOTER //
// ./src/common/schema.js